import React from "react";
import PropTypes from "prop-types";

import InfoBlock from "./InfoBlock";

const InfoEmpty = props => (
	<InfoBlock className="hidden-xs hidden-sm">
		{/* hidden-xs und hidden-sm sind bootstrap CSS-Klassen, die nicht
		  * über react-bootstrap verfügbar sind (?)
		  */}
		<div style={{ height: props.height }} />
	</InfoBlock>
);

InfoEmpty.propTypes = {
	height: PropTypes.string
};

export default InfoEmpty;
